/** GameRefinery's own organization in the account server. Its users are the analysts. */
export const GAMEREFINERY_ORGANIZATION_ID = '5658315e073b6178260f5ef6'
